import React from "react";

interface BurgerIconProps {
    className?: string;
}

export default function BurgerIcon({ className }: BurgerIconProps) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 80"
            width="40"
            height="40">

            <rect y="4" width="100" height="15" rx="8"></rect>
            <rect y="34" width="100" height="15" rx="8"></rect>
            <rect y="64" width="100" height="15" rx="8"></rect>
        </svg>
    );
}
